import { render, staticRenderFns } from "./detailsAcceptanceRecord.vue?vue&type=template&id=6f002c65&scoped=true"
import script from "./detailsAcceptanceRecord.vue?vue&type=script&lang=js"
export * from "./detailsAcceptanceRecord.vue?vue&type=script&lang=js"
import style0 from "./detailsAcceptanceRecord.vue?vue&type=style&index=0&id=6f002c65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f002c65",
  null
  
)

export default component.exports